
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'not-found',
})
export default class NotFound extends Vue {}
